import React, { useRef, useState, useEffect } from "react";
import { Canvas, extend, useThree, useFrame } from "@react-three/fiber";
import { OrbitControls, PerspectiveCamera } from "@react-three/drei";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import gsap from 'gsap';

extend({ OrbitControls });

const Hrsch = () => {
  const [model, setModel] = useState(null);
  const meshRef = useRef();

  useEffect(() => {
    new GLTFLoader().load(
      process.env.PUBLIC_URL + "models/hrsch/hrsch.gltf",
      setModel
    );
  }, []);

  useFrame(({ mouse }) => {
    const { x, y } = mouse;
    gsap.to(meshRef.current.rotation, {
      x: Math.PI / 100 + y * 0.2,
      y: Math.PI / 100 + x * 0.2,
      duration: 0.5,
    });
  });

  if (meshRef.current) {
    meshRef.current.rotation.x = Math.PI / 100;
    meshRef.current.rotation.y = Math.PI / 100;
  }

  return (
    <mesh ref={meshRef}>{model && <primitive object={model.scene}/>}</mesh>
  );
};

export default Hrsch;
